// src/pages/services/ShirodharaTreatment.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import leaf from '../../assets/leaf1.png';
import heroImg from '../../assets/Shirodhara Treatment.png';
import doctorImg from '../../assets/doctors4.png';
import Navbar from '../../common/Navbar';
import Footer from '../../common/Footer';

const ShirodharaTreatment = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-sm md:text-base leading-relaxed">
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#E8E0D5] to-[#F8F3EA]">
        <div className="absolute inset-0 bg-black/40 z-10"></div>
        <img src={heroImg} alt="Shirodhara" className="absolute inset-0 w-full h-full object-cover" />
        
        <div className="relative z-20 text-center px-6 max-w-5xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-playfair font-bold text-white mb-6 drop-shadow-2xl">
            Shirodhara Treatment
          </h1>
          <p className="text-lg md:text-2xl lg:text-3xl text-white/95 font-light leading-relaxed max-w-4xl mx-auto drop-shadow-lg">
            The ultimate mind-calming therapy. Warm herbal oil flows rhythmically over the forehead, melting stress and restoring inner peace.
          </p>
        </div>

        <img src={leaf} className="absolute top-20 left-10 w-32 opacity-30 animate-float" />
        <img src={leaf} className="absolute bottom-32 right-16 w-40 opacity-25 animate-float" style={{ animationDelay: '2s' }} />
      </section>

      {/* BENEFITS SECTION */}
      <section className="py-24 px-6 bg-[#F8F3EA]">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-playfair text-[#0B2A2C] mb-16">
            Profound Benefits
          </h2>
          <div className="grid md:grid-cols-3 gap-10">
            {[
              { icon: "", title: "Deep Relaxation", desc: "Reduces anxiety and mental fatigue" },
              { icon: "", title: "Nervous System Balance", desc: "Calms Vata dosha instantly" },
              { icon: "", title: "Better Sleep", desc: "Promotes deep, restorative rest" }
            ].map((b, i) => (
              <div key={i} className="bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-3">
                <div className="text-6xl mb-6">{b.icon}</div>
                <h3 className="text-2xl font-bold text-[#0B2A2C] mb-4">{b.title}</h3>
                <p className="text-gray-700 text-base leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* QUOTE SECTION */}
      <section className="py-24 bg-gradient-to-r from-[#0B2A2C] to-[#1A4D4F] text-white text-center px-6">
        <img 
          src={doctorImg} 
          alt="Dr. Rao"
          className="w-36 h-36 sm:w-64 sm:h-64 rounded-full mx-auto mb-6 sm:mb-12 border-4 sm:border-8 border-amber-300/30 shadow-2xl"
        />
        <blockquote className="text-2xl md:text-4xl font-joan italic max-w-4xl mx-auto leading-relaxed">
          “Shirodhara is the queen of all treatments — it stills the mind like nothing else.”
        </blockquote>
        <p className="text-sm sm:text-base md:text-lg opacity-90">
          — Dr. V. K. Subrahmanyeswara Rao, MD (Ayurveda) Gold Medalist
        </p>
      </section>

      {/* FINAL CTA */}
      <section className="py-24 text-center bg-[#F8F3EA]">
        <h2 className="text-3xl text-center sm:text-4xl md:text-5xl font-playfair text-[#0B2A2C] mb-10 sm:mb-16">
          Experience True Calm
        </h2>
        <button 
          onClick={() => navigate("/BookNow")} 
          className="bg-[#0B2A2C] text-white px-16 py-6 rounded-full text-xl md:text-2xl font-medium hover:bg-[#1A4D4F] transition-all hover:shadow-2xl hover:scale-105"
        >
          Book Shirodhara Session
        </button>
      </section>

      <Footer />
    </div>
  );
};

export default ShirodharaTreatment;